module.exports = __webpack_public_path__ + "img/bb7e4e0.jpeg";